<template>
  <div
    v-if="showScrollIndicator"
    class="scroll-indicator"
    @click="scrollToTop"
  ></div>
</template>

<script>
export default {
  name: "Scroll",

  data() {
    return {
      showScrollIndicator: false,
      lastScrollY: 0
    };
  },

  mounted() {
    this.lastScrollY = window.scrollY;
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {
      const current = window.scrollY;

      this.showScrollIndicator =
        current > 300 && current < this.lastScrollY;

      this.lastScrollY = current;
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style scoped>
    .scroll-indicator {
        position: fixed;
        right: 32px;
        bottom: 32px;

        width: 50px;
        height: 50px;
        border-radius: 50%;

        background: #D9B44A;
        cursor: pointer;

        box-shadow: 0 8px 24px rgba(0,0,0,.18);
        transition: all .25s ease;
        z-index: 999;

        display: flex;
        justify-content: center;
        align-items: center;
    }

    .scroll-indicator::before {
        content: "";
        width: 7px;
        height: 7px;

        border-top: 2px solid #fff;
        border-left: 2px solid #fff;

        transform: rotate(45deg) translate(1px, 1px);
    }

    .scroll-indicator:hover {
        background: #e8c764;
        transform: scale(1.12);
    }

    @media only screen and (max-width: 700px){
        .scroll-indicator {
                width: 45px;
                height: 45px;
        }
    }
</style>